module.exports = require('./shared-g11n');